import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';

import { fallDown as Menu } from 'react-burger-menu';
import logo from '../../assets/img/logo.svg';
import downArr from '../../assets/img/down-arr.svg';
import burger from '../../assets/img/burger.svg';
import close from '../../assets/img/close-x.svg';
import { SamplesActions, pageActions } from './../../actions';

class MobileHeader extends React.Component {
    
    handleMenuStateChange = (state) => {
        this.props.openMobileMenu(state.isOpen);
    }

    closeMenu = () => {
        this.props.openMobileMenu(false);
    }

    closeMenuOnRouteChange = () =>{
        this.unlisten = this.props.history.listen(location => {
            this.closeMenu();
        });
    }

    // isEndofPage = () => window.innerHeight + 1 + window.scrollY >= document.body.scrollHeight;
    
    openSamples = (e) => {
        e.stopPropagation();
        const {samplesopened} = this.props;
        this.props.openSamples(!samplesopened);
    }
    render (){
        const {langTxt, langUrl, samplesopened, samplesCount,menuOpen} = this.props;
        const openedClass = samplesopened? 'samples-opened' : '';
        return (
            <div className="mob-menu-container">
                <div className="mobile-logo">
                    <Link to={langUrl}>
                        <img src={logo} alt="mobile logo"/>
                    </Link>
                    <div className={"menu-open-btn cursor-pointer " + openedClass} onClick={(e)=>{this.openSamples(e)}}>
                        <p className="my-samples">My Samples</p>
                        <p className="samples-number">{samplesCount}</p>
                        <img src={downArr} alt="down-arr"/>
                    </div>
                </div>
                
                <div className="mobile-menu">
                    
                    <Menu
                        isOpen={menuOpen}
                        onStateChange={(state) => this.handleMenuStateChange(state)}
                        customBurgerIcon={(!menuOpen)? <img src={burger} alt="burger"/>: <img src={close} alt="burger"/> }
                        width={ '100%' }
                        disableAutoFocus
                    >
                        <div className="menu-links">
                            <Link to={langUrl+"/collections"}>Collections</Link>
                            <Link to={langUrl+"/blog"}>Blog</Link>
                            <Link to={langUrl+"/about"}>About</Link>
                        </div>
                        {(langTxt === "en")? <a className="cursor-pointer lang-btn" href="/fr">Fr</a>: <a className="cursor-pointer lang-btn" href="/">En</a>}
                    </Menu>    
                </div>
            </div>      
        );
    }
}

// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        samplesCount: (state.samples && state.samples.list)? state.samples.list.length : 0,
        samplesopened: (state.samples && state.samples.opened),
        menuOpen: (state.page && state.page.isMobMenuOpen),
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
        openSamples: (isOpened) => dispatch(SamplesActions.open(isOpened)),
        openMobileMenu : (isOpened) => dispatch(pageActions.openMobileMenu(isOpened))
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(MobileHeader) );